import PropTypes from "prop-types";
import { Modal } from "react-bootstrap"
import Button from "../common/Button";
import Form from "../common/Form";
import Input from "../commonComponents/Input";
import disable_link from "../../svg/disable-link.svg";
import active_link from "../../svg/active-link.svg";
import back_arrow_active from "../../svg/back-arrow-active.svg";

const UploadUrlModal = (props) => {
    const { show, close, handleBack,handleuploadUrl, url,setUrl} = props
    return (
        <Modal show={show} centered size="md">
            {/* <Form onSubmit={handleuploadUrl}> */}
                <div class="modal-dialog-centered">
                    <div class="">
                        <div class="modal-header">
                            <a class="link-back link" onClick={() => handleBack()}>
                                <img src={back_arrow_active} alt="back" className="me-1" />
                                 Back
                            </a>
                            <h5 class="modal-title">Professional Presence</h5>
                            <p>Please add the URL of the platform you want to showcase</p>
                            <button type="button" class="btn-close"  onClick={close}></button>
                        </div>
                        <div class="modal-body">
                            <div class="px-2 pt-1">
                                <div class="fieldWrap">
                                    <div class="fieldCover">
                                        <img src={url ? active_link : disable_link} className="pre-icon" alt="link" />
                                        <Input handleChange={(e)=>setUrl(e.target.value)} className="fieldForm"  value={url} type="url" placeholder="Add URL" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <Button title='Submit' disabled={!url} handleClick={(e)=>handleuploadUrl(e)} className="button button-primary w-50 mb-4" />
                        </div>
                    </div>
                </div>
            {/* </Form> */}
        </Modal>
    )
}
UploadUrlModal.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    handleAddUrlModal: PropTypes.func,
    handleBack: PropTypes.func,
    handleuploadUrl:PropTypes.func,
    url:PropTypes.string,
    setUrl:PropTypes.func
};

UploadUrlModal.defaultProps = {
    show: false,
    close: () => null,
    handleAddUrlModal: () => null,
    handleBack: () => null,
    handleuploadUrl:()=>null,
    url:'',
    setUrl:()=>null
};

export default UploadUrlModal